import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDuetSummary } from '../hooks/queries';

let startTabApplied = false;

/**
 * Duet outside its tab: the app opens on Duet when the user chose that as start tab (once per
 * load, only from the home screen), and the app icon shows what waits there where supported.
 */
export function DuetBridge() {
  const { data } = useDuetSummary();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!data || startTabApplied) return;
    startTabApplied = true;
    if (data.defaultTab === 'duet' && location.pathname === '/')
      navigate('/nivi', { replace: true });
  }, [data, location.pathname, navigate]);

  const waiting = data ? data.unseen + data.pendingApprovals : 0;
  useEffect(() => {
    const nav = navigator as Navigator & {
      setAppBadge?: (count?: number) => Promise<void>;
      clearAppBadge?: () => Promise<void>;
    };
    const update = waiting > 0 ? nav.setAppBadge?.(waiting) : nav.clearAppBadge?.();
    void update?.catch(() => undefined);
  }, [waiting]);

  return null;
}
